module.exports = __webpack_public_path__ + "static/img/customerService.8bf7fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/customerService.png
// module id = feZX
// module chunks = 54